import {
  DialogContent,
  Dialog as MUIDialog,
  DialogActions as MUIDialogActions,
} from '@mui/material';
import styled from 'styled-components';

const DialogWrapper = styled(MUIDialog)<{ $fitsContent?: boolean }>`
  .MuiDialog-paper {
    background-color: ${({ theme }) => theme.palette.background.default};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    height: fit-content;
    justify-content: space-around;
    max-height: 95%;
    min-width: ${({ theme }) => theme.breakpoints.values['sm'] + 'px'};
    max-width: ${({ theme, $fitsContent, maxWidth }) => {
      if (maxWidth) {
        return theme.breakpoints.values[maxWidth] + 'px';
      }

      return $fitsContent ? 'fit-content' : '750px';
    }};
    width: ${({ $fitsContent, fullScreen, maxWidth }) => {
      if (maxWidth) {
        return undefined;
      }

      if ($fitsContent) {
        return 'unset';
      }

      return fullScreen ? '95%' : '475px';
    }};
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;

  */ & > * {
    margin: 0 0 ${({ theme }) => theme.spacing(4)} 0;
    padding: 0;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

const DialogHeader = styled.header`
  align-items: center;
  display: flex;
  height: 3rem;
  justify-content: center;
  position: relative;
`;

const DialogHeaderCloseButton = styled.button`
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  padding: 0;
  position: absolute;
  right: ${({ theme }) => `${theme.spacing(2)}`};
  top: ${({ theme }) => `${theme.spacing(2)}`};
`;

const DialogContentWrapper = styled(DialogContent)`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 !important;
  font-size: 1rem;
`;

const DialogActionsWrapper = styled(MUIDialogActions)`
  align-items: center;
  display: flex;
  height: 20%;
  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(3)}`} !important;
  &.MuiDialogActions-root {
    align-items: center;
    justify-content: center;
  }
`;

const DialogActionsButtonsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: space-between;
  width: 100%;

  & > * {
    width: 48%;

    &:only-child {
      width: 100%;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.values.sm + 'px'}) {
    align-items: space-between;
    flex-direction: column-reverse;

    & > * {
      width: 100%;

      &:not(:first-child) {
        margin-bottom: 0.5rem;
      }
    }

    :only-child {
      width: 100%;
    }
  }
`;

const Separator = styled('div')`
  border-color: ${({ theme }) => theme.palette.grey[300]};
  border-style: solid;
  border-width: 1px 0 0;
  width: 100%;
`;

export {
  DialogWrapper,
  DialogHeader,
  ContentContainer,
  DialogHeaderCloseButton,
  DialogContentWrapper,
  DialogActionsWrapper,
  DialogActionsButtonsWrapper,
  Separator,
};
